// -- Lifecycle hooks
if (!customElements.get('momax-peace')) {
  customElements.define('momax-peace', class extends HTMLElement {
    connectedCallback() {
      // -- State and variables
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.track = this.querySelector('.momax-peace__track');
      this.cards = [...this.track.children];
      this.progress = this.querySelector('.momax-peace__progress');
      this.mobile = matchMedia('(max-width: 740px)');
      // The reference groups six policies into three progress segments.
      this.progress.replaceChildren(...Array.from({ length: Math.ceil(this.cards.length / 2) }, () => document.createElement('span')));

      // -- Listeners
      this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
      this.track.addEventListener('keydown', event => {
        if (!this.mobile.matches || event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const step = (this.cards[0]?.getBoundingClientRect().width || 0) + 16;
        this.move(event.key === 'Home' ? 0 : event.key === 'End' ? this.track.scrollWidth : this.track.scrollLeft + (event.key === 'ArrowLeft' ? -step : step));
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.momax-peace__card');
        if (card && this.mobile.matches) this.move(this.position(card));
      }, { signal });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }

    // -- Functions
    position(card) {
      return this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left - 20;
    }

    move(left) {
      this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.progress.hidden = !this.mobile.matches || max <= 1;
      this.track.tabIndex = this.mobile.matches && max > 1 ? 0 : -1;
      let active = 0;
      let distance = Infinity;
      this.cards.forEach((card, index) => {
        const delta = Math.abs(this.position(card) - this.track.scrollLeft);
        if (delta < distance) { active = index; distance = delta; }
      });
      if (max > 1 && this.track.scrollLeft >= max - 1) active = this.cards.length - 1;
      [...this.progress.children].forEach((dot, index) => dot.toggleAttribute('data-active', index === Math.floor(active / 2)));
    }

    // -- Lifecycle hooks
    disconnectedCallback() {
      this.controller.abort();
      this.observer.disconnect();
    }
  });
}
